/**
 * @desc 查看参数列表中的分段列表
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {
  /** factoryCode */
  factoryCode: string;
}

export function request(
  params: Params,
): Promise<defs.StandardReturn<Array<defs.ParamSectionResponse>>> {
  return defHttp.get({
    url: '/wap/ParamManage/getSection',

    params,
  });
}

export function mock(
  params: Params,
): Promise<defs.StandardReturn<Array<defs.ParamSectionResponse>>> {
  return defHttp.get({
    url: '/mock/wap/ParamManage/getSection',

    params,
  });
}
